import { useState, useEffect } from "react";
import api from "../services/api";
import { useNavigate, useLocation } from "react-router-dom";

const FormularioRegistro = () => {
  const [IdTipoDocumento, setIdTipoDocumento] = useState("");
  const [tipoDocumento, setTipoDocumento] = useState([]);
  const [IdPais, setIdPais] = useState("");
  const [nombrePais, setNombrePais] = useState([]);
  const [Email, setEmail] = useState("");
  const [Documento, setDocumento] = useState("");
  const [Nombre, setNombre] = useState("");
  const [Apellido, setApellido] = useState("");
  const [Username, setUsername] = useState("");
  const [Password, setPassword] = useState("");
  const [IdPerfil, setIdPerfil] = useState("");
  const [perfiles, setPerfiles] = useState([]);
  const [zonasSanitarias, setZonasSanitarias] = useState([]);
  const [patologias, setPatologias] = useState([]);
  const [zonasSeleccionadas, setZonasSeleccionadas] = useState([]);
  const [patologiasSeleccionadas, setPatologiasSeleccionadas] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();

  const limpiarCampos = () => {
    setUsername("");
    setPassword("");
    setNombre("");
    setApellido("");
    setEmail("");
    setDocumento("");
    setIdPais("");
    setIdTipoDocumento("");
    setZonasSeleccionadas([]);
    setPatologiasSeleccionadas([]);
  };

  // Solo carga datos iniciales una vez
  useEffect(() => {
    getPaises();
    getPerfiles();
    getZonasSanitarias();
    getPatologias();
  }, []);

  // Limpia campos cada vez que cambia la ruta (se muestra el formulario)
  useEffect(() => {
    limpiarCampos();
  }, [location.pathname]);

  // Carga países
  const getPaises = async () => {
    try {
      const response = await api.get(`/paises`);
      setNombrePais(response.data);
    } catch (error) {
      console.error("Error cargando países:", error);
    }
  };

  const getPerfiles = async () => {
    try {
      const response = await api.get(`/perfiles/public`);
      const perfilesData = response.data || [];
      setPerfiles(perfilesData);

      if (!IdPerfil && perfilesData.length > 0) {
        const perfilUsuario = perfilesData.find((perfil) => Number(perfil.idPerfil) === 2);
        setIdPerfil(String(perfilUsuario ? perfilUsuario.idPerfil : perfilesData[0].idPerfil));
      }
    } catch (error) {
      console.error("Error cargando perfiles:", error);
      setPerfiles([]);
    }
  };

  const getZonasSanitarias = async () => {
    try {
      const response = await api.get(`/zonas-sanitarias`);
      setZonasSanitarias(response.data || []);
    } catch (error) {
      console.error("Error cargando zonas sanitarias:", error);
      setZonasSanitarias([]);
    }
  };

  const getPatologias = async () => {
    try {
      const response = await api.get(`/patologias`);
      setPatologias(response.data || []);
    } catch (error) {
      console.error("Error cargando patologías:", error);
      setPatologias([]);
    }
  };

  const handleToggleZona = (idZonaSanitaria) => {
    setZonasSeleccionadas((prev) => {
      const id = Number(idZonaSanitaria);
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id);
      }
      return [...prev, id];
    });
  };

  const handleTogglePatologia = (idPatologia) => {
    setPatologiasSeleccionadas((prev) => {
      const id = Number(idPatologia);
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id);
      }
      return [...prev, id];
    });
  };

  // Cuando cambia el país, carga tipos de documento
  useEffect(() => {
    if (!IdPais) {
      setTipoDocumento([]);
      setIdTipoDocumento("");
      return;
    }
    const getTipoDocumentosPorPais = async () => {
      try {
        const response = await api.get(`/tipodocumentos/${IdPais}`);
        setTipoDocumento(response.data);
        setIdTipoDocumento(""); // reset tipo documento para que el usuario elija uno válido
      } catch (error) {
        console.error("Error cargando tipos de documento:", error);
      }
    };
    getTipoDocumentosPorPais();
  }, [IdPais]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (zonasSeleccionadas.length === 0) {
      alert("Debes seleccionar al menos una zona sanitaria");
      return;
    }

    if (patologiasSeleccionadas.length === 0) {
      alert("Debes seleccionar al menos una patología");
      return;
    }

    try {
      const registerResponse = await api.post(`/usuarios/register`, {
        Username,
        Password,
        Email,
        Nombre,
        Apellido,
        IdPais: Number(IdPais),
        IdTipoDocumento: Number(IdTipoDocumento),
        Documento,
        IdPerfil: Number(IdPerfil),
      });

      const idUsuario = Number(registerResponse?.data?.idUsuario);

      if (idUsuario && zonasSeleccionadas.length > 0) {
        await api.post(`/usuarios/asignar-zonas-sanitarias`, {
          IdUsuario: idUsuario,
          Zonas: zonasSeleccionadas,
        });
      }

      if (idUsuario && patologiasSeleccionadas.length > 0) {
        await Promise.all(
          patologiasSeleccionadas.map((idPatologia, index) =>
            api.post(`/patologias-usuario`, {
              idUsuario,
              idPatologia,
              esDefault: index === 0,
            })
          )
        );
      }

      alert("Usuario registrado correctamente");
      navigate("/login");
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.msg || "Error al registrar");
    }
  };

  return (
    <div className="column mt-5 is-6 is-offset-3">
      <form className="box" onSubmit={handleSubmit}>
        <div className="field">
          <label className="label">Nombre de usuario</label>
          <input
            className="input is-rounded"
            type="text"
            value={Username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>

        <div className="field">
          <label className="label">Contraseña</label>
          <input
            className="input is-rounded"
            type="password"
            value={Password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <div className="field">
          <label className="label">Nombres</label>
          <input
            className="input is-rounded"
            type="text"
            value={Nombre}
            onChange={(e) => setNombre(e.target.value)}
            required
          />
        </div>

        <div className="field">
          <label className="label">Apellidos</label>
          <input
            className="input is-rounded"
            type="text"
            value={Apellido}
            onChange={(e) => setApellido(e.target.value)}
            required
          />
        </div>

        <div className="field">
          <label className="label">Email</label>
          <input
            className="input is-rounded"
            type="email"
            value={Email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="field">
          <label className="label">Nacionalidad</label>
          <div className="select is-rounded is-fullwidth">
            <select
              value={IdPais}
              onChange={(e) => setIdPais(e.target.value)}
              required
            >
              <option value="">Seleccionar</option>
              {nombrePais.map((pais) => (
                <option key={pais.IdPais} value={pais.IdPais}>
                  {pais.Nombre}
                </option>
              ))}
            </select>
          </div>
        </div>

        <label className="label">Documento</label>
        <div className="field docbox">
          <div className="select is-rounded selectdocbox">
            <select
              value={IdTipoDocumento}
              onChange={(e) => setIdTipoDocumento(e.target.value)}
              required
              disabled={!tipoDocumento.length}
            >
              <option value="">Seleccionar</option>
              {tipoDocumento.map((tipo) => (
                <option key={tipo.idTipoDocumento} value={tipo.idTipoDocumento}>
                  {tipo.TipoDocumento}
                </option>
              ))}
            </select>
          </div>
          <div className="control docinput">
            <input
              className="input is-rounded"
              type="text"
              placeholder="Número de Documento"
              value={Documento}
              onChange={(e) => setDocumento(e.target.value)}
              required
            />
          </div>
        </div>

        <div className="field">
          <label className="label">Perfiles</label>
          <div className="select is-rounded is-fullwidth">
            <select
              value={IdPerfil}
              onChange={(e) => setIdPerfil(e.target.value)}
              required
              disabled={!perfiles.length}
            >
              <option value="">Seleccionar Perfil</option>
              {perfiles.map((perfil) => (
                <option key={perfil.idPerfil} value={perfil.idPerfil}>
                  {perfil.nombre}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="field">
          <label className="label">Zonas sanitarias</label>
          <div className="box" style={{ maxHeight: "180px", overflowY: "auto" }}>
            {zonasSanitarias.length === 0 ? (
              <p>No hay zonas sanitarias disponibles.</p>
            ) : (
              zonasSanitarias.map((zona) => (
                <label key={zona.IdZonaSanitaria} className="checkbox" style={{ display: "block", marginBottom: "8px" }}>
                  <input
                    type="checkbox"
                    checked={zonasSeleccionadas.includes(Number(zona.IdZonaSanitaria))}
                    onChange={() => handleToggleZona(zona.IdZonaSanitaria)}
                    style={{ marginRight: "8px" }}
                  />
                  {zona.Nombre}
                </label>
              ))
            )}
          </div>
        </div>

        <div className="field">
          <label className="label">Patologías</label>
          <div className="box" style={{ maxHeight: "180px", overflowY: "auto" }}>
            {patologias.length === 0 ? (
              <p>No hay patologías disponibles.</p>
            ) : (
              patologias.map((patologia) => (
                <label key={patologia.IdPatologia} className="checkbox" style={{ display: "block", marginBottom: "8px" }}>
                  <input
                    type="checkbox"
                    checked={patologiasSeleccionadas.includes(Number(patologia.IdPatologia))}
                    onChange={() => handleTogglePatologia(patologia.IdPatologia)}
                    style={{ marginRight: "8px" }}
                  />
                  {patologia.Nombre}
                </label>
              ))
            )}
          </div>
        </div>

        <button type="submit" className="button is-success">
          Registrar
        </button>
      </form>
    </div>
  );
};

export default FormularioRegistro;